module.exports = __webpack_public_path__ + "static/img/3.17ce9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/docs/image/3.png
// module id = 678
// module chunks = 1